import React, { useState } from 'react';
import Form from '../../components/common/Form';
import FormSection from '../../components/common/FormSection';
import FormField from '../../components/common/FormField';
import { InvoiceTypeDTO } from '../../services/apiClient';
import handleChange from '../../utils/formUtils/handleChange';
import { useFormValidation, ValidationRules } from '../../hooks/useFormValidation';

interface InvoiceTypeFormProps {
  initialValues: InvoiceTypeDTO;
  onSubmit: (data: InvoiceTypeDTO) => void;
  onCancel: () => void;
  isLoading?: boolean;
}

const FORM_SECTIONS = {
  basicInfo: {
    id: 'basic-info',
    title: 'Basic Information'
  }
} as const;

const InvoiceTypeForm: React.FC<InvoiceTypeFormProps> = ({
  initialValues,
  onSubmit,
  onCancel,
  isLoading = false
}) => {
  const [formData, setFormData] = useState<InvoiceTypeDTO>(initialValues);

  
            const validationRules: ValidationRules = {
                    name: [
      { required: true, message: 'Name is required' }
    ],
    prefix: [
      { required: true, message: 'Prefix is required' }
    ],
    lastUsedNumber: [
      { required: true, message: 'Last Used Number is required' },
      { custom: (value) => Number(value) >= 0, message: 'Last Used Number must be a positive number' }
    ]
            };

  const { errors, validate } = useFormValidation<InvoiceTypeDTO>(validationRules);

  const handleSave = () => {
    if (validate(formData)) {
      onSubmit(formData);
    }
  };

  const sections = Object.values(FORM_SECTIONS);

  return (
    <Form sections={sections} onSave={handleSave} onCancel={onCancel} isSubmitting={isLoading}>
      <FormSection 
        id={FORM_SECTIONS.basicInfo.id} 
        title={FORM_SECTIONS.basicInfo.title}
      >
                <FormField
          id="name"
          label="Name"
          type="text"
          value={formData.name || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter Name"
          required={true}
          error={errors.name}
        />
        <FormField
          id="description"
          label="Description"
          type="text"
          value={formData.description || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter Description"
          required={false}
          error={errors.description}
        />
        <FormField
          id="prefix"
          label="Prefix"
          type="text"
          value={formData.prefix || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter Prefix"
          required={true}
          error={errors.prefix}
        />
        <FormField
          id="lastUsedNumber"
          label="Last Used Number"
          type="number"
          value={formData.lastUsedNumber || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter Last Used Number"
          required={true}
          error={errors.lastUsedNumber}
        />

      </FormSection>
    </Form>
  );
};

export default InvoiceTypeForm;